<template>
    <div class="et_pb_section et_pb_section_1 et_section_regular">
        <div class="seco-contact-productdivision">
            <p class="seco-contact-productdivision__subtitle">{{ translate.use_our_system }}</p>

            <div id="productdivision" class="seco-contact-productdivision__select">
                <model-select :options="countriesOptions"
                              v-model="country"
                              placeholder="Select country">
                </model-select>
                <div @click="find"
                     class="seco-contact-productdivision__button seco-contact-productdivision__button--primary seco-contact-productdivision__button--large">
                    <span class="seco-contact-productdivision__find-button">{{ translate.find }}</span>
                    <span class="seco-contact-productdivision__find-icon"><i class="fa fa-search" aria-hidden="true"></i></span>
                </div>
            </div>
            <div class="seco-contact-productdivision__line">
                <hr/>
            </div>
            <transition name="fade" mode="out-in">
                <div v-if="productdivision && show" class="seco-contact-productdivision__contacts">
                    <div class="seco-contact-productdivision__contacts__header">
                        <h2 class="seco-contact-productdivision__contacts__header__title">{{ translate.support_for }} {{ country.text }}</h2>
                        <div v-if="notFound" class="seco-alert seco-alert--danger">
                            {{ translate.contact_poland }}
                        </div>
                        <div class="seco-contact-productdivision__contacts__header__content" v-html="productdivision.content"></div>
                    </div>
                    <div class="seco-contact-productdivision__contacts__list">
                        <div v-for="employee in productdivision.employees" v-bind:key="employee.ID" class="scs-persons">
                            <div class="scs-persons__avatar"
                                 v-bind:style="{ backgroundImage: 'url(' + employee.featured_image.medium + ')' }">
                            </div>
                            <div class="scs-persons__contact">
                                <div class="scs-persons__contact__title">{{ employee.mobile }}</div>
                              <div v-if="employee.mobile && employee.mobile.length > 0"
                                   class="scs-persons__contact__header">
                                {{ employee.product_header }}
                              </div>
                                <div v-if=" employee.surname && employee.surname.length > 1"
                                     class="scs-persons__contact__name">
                                    <i class="fa fa-user" aria-hidden="true"></i>
                                    {{ employee.first_name }} {{ employee.surname }}
                                </div>
                                <div v-if="employee.phone_service && employee.phone_service.length > 0"
                                     class="scs-persons__contact__phone">
                                    <i class="fa fa-phone" aria-hidden="true"></i>
                                    {{ employee.phone_service }}
                                </div>
                                <div v-if="employee.email && employee.email.length > 0"
                                     class="scs-persons__contact__email">
                                    <i class="fa fa-envelope" aria-hidden="true"></i>
                                    {{ employee.email }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="isError">
                    <div class="seco-alert seco-alert--danger">{{ translate.contact_error }}</div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import {ModelSelect} from 'vue-search-select'
    import 'vue-search-select/dist/VueSearchSelect.css'
    import Translate from '../config/translate'
    import CountriesDE from '../config/de/countries'
    import CountriesEN from '../config/en/countries'
    import CountriesPL from '../config/pl/countries'
    import CountriesRU from '../config/ru/countries'

    export default {
        name: 'ProductDivision',
        components: {
            ModelSelect
        },
        props: {
            lang: String,
            section:String,
        },
        data: function () {
            return {
                isError: false,
                show: false,
                notFound: false,
                translate: {},
                defaultCountry: {
                    value: 'pl',
                    text: 'Poland'
                },

                country: {
                    value: '',
                    text: ''
                },
              productdivisions: []
            }
        },
        methods: {
            canFind() {
                return (this.country.value && this.country.value.length > 0 && this.section.length > 0)
            },
            find() {
                let item = document.querySelector('#productdivision');
                if (item) {
                    item.scrollIntoView({
                        behavior: 'smooth'
                    });
                }
            },
            setTranslate() {
                this.translate = Translate[this.lang]
            },
            fetch() {
                let self = this
                // let api = 'http://www.secowarwick.com:82/' + this.lang + '/wp-json/swpd/productdivision'
                let api = 'https://www.secowarwick.com/' + this.lang + '/wp-json/swpd/productdivision'
                const myRequest = new Request(api)
                // const myRequest = new Request('https://www.secowarwick.com/wp-json/sws/productdivisions')
                fetch(myRequest)
                    .then((response) => {
                        return response.json()
                    })
                    .then((data) => {
                        self.productdivisions = data
                    }).catch(error => {
                    console.log(error);
                });
            }
        },
        computed: {
            countriesOptions: function () {
                let Countries = {}
                switch (this.lang) {
                    case 'de':
                        Countries = CountriesDE
                        break;
                    case 'pl':
                        Countries = CountriesPL
                        break;
                    case 'ru':
                        Countries = CountriesRU
                        break;
                    case 'en':
                    default:
                        Countries = CountriesEN
                }


                let countriesOptions = []
                Object.keys(Countries).map(function (key) {
                    countriesOptions.push({
                        value: key,
                        text: Countries[key]
                    })
                });
                return countriesOptions.sort((a, b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0))
            },
            productdivision: function () {
                let item = null
                let country = this.country.value
                if (this.canFind()) {
                    item = this.productdivisions.find(record => {
                        return (record.section === this.section && record.countries.includes(country))
                    })
                }
                if (this.canFind() && !item) {
                    country = this.defaultCountry.value
                    item = this.productdivisions.find(record => {
                        return (record.section === this.section && record.countries.includes(country))
                    })
                }
                return item;
            }
        },
        watch: {
            productdivision: function (productdivision) {
                this.show = false
                if ((this.canFind() && productdivision)
                    && !productdivision.countries.includes(this.country.value)
                    && productdivision.countries.includes(this.defaultCountry.value)
                    && this.country.value !== this.defaultCountry.value) {
                    this.notFound = true
                } else {
                    this.notFound = false
                }
                this.isError = (this.canFind() && !productdivision)

              if(!this.isError && !this.notFound){
                this.show = true
              }
                this.$nextTick(() => {
                    this.show = true
                });
            }
        },
        mounted() {
            this.fetch()
            this.setTranslate()
        }
    }
</script>

<style>
    @import url('https://fonts.googleapis.com/css2?family=Titillium+Web:wght@400;700&display=swap');

    .fade-enter-active, .fade-leave-active {
        transition: opacity 1s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }

    .seco-contact-productdivision {
        font-family: 'Titillium Web', sans-serif;
    }

    .seco-contact-productdivision__title {

    }

    .seco-contact-productdivision__subtitle {
        letter-spacing: 0;
        font-size: 24px;
        margin: 16px 0;
    }

    .seco-contact-productdivision__select {
        display: flex;
        max-width: 650px;
        margin: auto;
    }

    .seco-contact-productdivision__buttons {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        margin: 50px auto 30px;
    }

    .seco-contact-productdivision__button {
        display: inline-block;
        white-space: nowrap;
        padding: 10px 30px;
        font: Bold 15px/23px Titillium Web;
        cursor: pointer;
    }

    .seco-contact-productdivision__button--primary {
        background-color: #DD0A1B;
        color: white;
        border: 2px solid #DD0A1B;
    }

    .seco-contact-productdivision__button--secondary {
        background-color: white;
        color: #464646;
        border: 2px solid #707070;
    }

    .seco-contact-productdivision__button--large {
        padding: 16px 31px;
        margin: 0 !important;
        width: auto !important;
    }

    .seco-contact-productdivision__find-button {
        display: inline;
    }

    .seco-contact-productdivision__find-icon {
        display: none;
    }

    .seco-contact-productdivision__line {
        margin-top: 100px;
        margin-bottom: 50px;
    }

    .seco-contact-productdivision__contacts {
        display: flex;
    }

    .seco-contact-productdivision__contacts__header {
        flex: 1;
        padding-right: 2rem;
    }

    .seco-contact-productdivision__contacts__header__title {
        font-size: 30px;
        letter-spacing: 0;
        color: #585858;
        text-transform: uppercase;
        position: relative;
        margin-bottom: 50px;
    }

    .seco-contact-productdivision__contacts__header__title:before {
        content: "";
        position: absolute;
        width: 56px;
        bottom: 0;
        border-bottom: 3px solid #dc291e;
    }

    .seco-contact-productdivision__contacts__header__content {

    }

    .seco-contact-productdivision__contacts__list {
        width: 450px;
    }

    .seco-alert {
        margin: 1rem 0;
        padding: .5rem 1rem;
    }

    .seco-alert--danger {
        background-color: #DD0A1B;
        color: white;
        font-weight: bold;
    }

    .scs-persons {
        display: flex;
        margin-bottom: 50px;
    }

    .scs-persons__avatar {
        width: 130px;
        height: 130px;
        border-radius: 50%;
        background-repeat: no-repeat;
        background-size: cover;
        -webkit-filter: grayscale(100%);
        filter: grayscale(100%);
    }

    .scs-persons__contact {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        line-height: 32px;
        color: #292929;
        margin-left: 20px;
    }

    .scs-persons__contact i.fa {
        color: #c8c8c8;
        margin-right: 5px;
    }

    .scs-persons__contact__title {
        font-weight: bold;
    }

    .ui.selection.dropdown {
        border: 2px solid #707070;
        border-radius: 0;
        height: 59px;

    }

    .ui.selection.dropdown:before {
        content: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="16.009" height="21.345" viewBox="0 0 16.009 21.345"> <path  d="M7.182,20.914C1.124,12.133,0,11.232,0,8A8,8,0,0,1,16.009,8c0,3.227-1.124,4.129-7.182,12.91a1,1,0,0,1-1.645,0ZM8,11.34A3.335,3.335,0,1,0,4.669,8,3.335,3.335,0,0,0,8,11.34Z" opacity="0.25"/></svg>');
    }

    .ui.selection.active.dropdown,
    .ui.selection.active.dropdown:hover,
    .ui.selection.active.dropdown .menu,
    .ui.selection.active.dropdown:hover .menu {
        border: 2px solid #707070;
    }

    .ui.selection.active.dropdown .menu {
        margin-left: -2px;
    }

    .ui.search.dropdown > input.search {
        height: 59px;
        margin-left: 34px;
    }

    .ui.fluid.dropdown > .dropdown.icon {
        margin-top: 0;
    }

    .ui.search.dropdown > .text {
        margin-top: 10px;
        margin-left: 20px;
        text-align: left;
        font-size: 17px;
        letter-spacing: 0;
        color: #464646;
        font-weight: bold;
    }

    @media (max-width: 1024px) {
        .seco-contact-productdivision__button {
            width: calc(50% - .5rem);
            margin: .25rem;
        }

        .seco-contact-productdivision__contacts {
            flex-wrap: wrap;
        }

        .seco-contact-productdivision__contacts__header {
            width: 100%;
        }

        .seco-contact-productdivision__contacts__list {
            width: 100%;
            margin-top: 50px;
        }
    }

    @media (max-width: 480px) {

        .seco-contact-productdivision__button {
            width: 100%;
            margin: .25rem 0 0 0;
        }

        .seco-contact-productdivision__find-button {
            display: none;
        }

        .seco-contact-productdivision__find-icon {
            display: inline;
        }

        .scs-persons {
            flex-wrap: wrap;
            justify-content: center;
        }

        .scs-persons__contact {
            width: 100%;
            margin-left: 0;
        }

        .ui.selection.dropdown:before {
            content: '';
        }

        .ui.search.dropdown > input.search {
            margin-left: 10px;
        }

        .ui.search.dropdown > .text {
            margin-top: 10px;
            margin-left: 0;
        }
    }
</style>
